import { useState } from "react";
import { BedDouble, X, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

// Optional hotel / start point from a pasted Google Maps link. Once set,
// every day starts and ends there — with the legs shown on the day cards.
export const HotelInput = ({ hotel, onChange }) => {
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);

  const resolve = async () => {
    const url = link.trim();
    if (!url || busy) return;
    setBusy(true);
    try {
      const { data } = await axios.get(`${API}/api/planner/resolve-place`, { params: { url } });
      onChange({ name: data.name, coords: [data.lat, data.lng] });
      setLink("");
      toast.success(`Starting every day from ${data.name}.`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't read that link — copy it from the hotel's own Google Maps page.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="planner-hotel" className="mt-4 border border-zinc-200 rounded-xl p-4 md:p-5 bg-[#FBFAF7]">
      <p className="font-body font-800 text-xs tracking-[0.25em] flex items-center gap-2 mb-2">
        <BedDouble size={14} className="text-[#DF3226]" /> WHERE ARE YOU STAYING?
        <span className="font-700 tracking-normal text-black/40 normal-case">optional — skip if you don&apos;t know yet</span>
      </p>
      {hotel ? (
        <div data-testid="planner-hotel-chip" className="inline-flex items-center gap-2 bg-black text-white font-body font-700 text-sm pl-3 pr-1.5 py-1.5 rounded-full">
          <BedDouble size={14} /> {hotel.name}
          <button
            type="button"
            data-testid="planner-hotel-remove"
            onClick={() => onChange(null)}
            aria-label="Remove hotel"
            className="grid place-items-center w-6 h-6 rounded-full hover:bg-[#DF3226] transition-colors"
          >
            <X size={13} />
          </button>
        </div>
      ) : (
        <div className="flex flex-col sm:flex-row gap-2">
          <input
            type="url"
            data-testid="planner-hotel-input"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && resolve()}
            placeholder="Paste your hotel's Google Maps link — days start and end from there"
            className="flex-1 font-body text-sm bg-white border border-zinc-300 rounded-lg px-3 py-2 focus:outline-none focus:border-black transition-colors"
          />
          <button
            type="button"
            data-testid="planner-hotel-set"
            onClick={resolve}
            disabled={!link.trim() || busy}
            className="inline-flex items-center justify-center gap-1.5 font-display font-800 text-sm bg-black text-white px-4 py-2 rounded-lg hover:bg-[#DF3226] disabled:opacity-40 disabled:hover:bg-black transition-colors"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : null} Set
          </button>
        </div>
      )}
    </div>
  );
};
